import { config } from "../config";

/**
 * Test mobile ranges (owner 2026-10-24; radius-wiki test-mobile-numbers.md).
 * India issues mobiles starting 6-9 only, so test numbers start 0-5 (44444,
 * 33333) and can never reach a real person. Only the TEST console has
 * config.testMobilePrefixes; live keeps the strict 6-9 rule. radaccess applies
 * the same rule from its range table, and radcomm logs, never sends, an SMS
 * to such a number inside a test tenant.
 */
export function testMobilePrefixes(): string[] {
  try {
    return (config().testMobilePrefixes ?? []).filter((p) => /^\d{2,10}$/.test(p));
  } catch {
    // Before /config.json loads (and in view tests) there are no test ranges.
    return [];
  }
}

/** Whether a 10-digit national number starts with a test prefix. */
export function isTestMobile(national10: string): boolean {
  return /^\d{10}$/.test(national10) && testMobilePrefixes().some((p) => national10.startsWith(p));
}

/** The one mobile rule: ten digits starting 6-9, or a test range. */
export function isMobile10(national10: string): boolean {
  return /^[6-9]\d{9}$/.test(national10) || isTestMobile(national10);
}
